import {
  IsNotEmpty,
  IsOptional,
  IsString,
  IsArray,
  IsObject
} from 'class-validator';
import { IBaseResponse } from '..';

export class IForm {
  _id?: string;
  name: string;
  description?: string;
  fields: IFormField[];
  organization: string;
  values?: Record<IFormFieldName, any>[];
  createdAt?: Date;
  updatedAt?: Date;
}

type IFormFieldName = string;
type IFormFieldCondition = {
  name: string;
  value: 'Yes' | 'No'; // only polar is supported now
};
export class IFormField {
  name: IFormFieldName;
  label: string;
  standaloneLabel?: boolean;
  placeholder?: string;

  type: FormFieldType;
  required?: boolean;
  /** can't be removed in form builder and has to exist */
  mandatory?: boolean;
  defaultValue?: any;

  /** hide the field from UI, it will not show in form and will be filled pragmatically instead by user input */
  isHidden?: boolean;

  /** width percent ex: '25%' */
  width?: string;

  min?: number;
  max?: number;

  options?: string[];

  conditions?: IFormFieldCondition[];

  /** the group name for this field */
  group?: string;
  // group field options
  fields?: IFormField[];
  repeatType?: 'user' | 'constant' | 'field';
  repeatFieldName?: string;
  repeatConstant?: number;

  /** ex: stripe public key for credit card field */
  publicKey?: string;

  /** core fields that represent a field for mongodb document, ex: email, firstName, lastName for lead schema
   * we set this manually from the database for now, we need to define these field for each org
   */
  isCoreSchemaField?: boolean;

  /**
   *  this field is set from the schema page
   */
  schema?: {
    groupId: string;
    groupTitle: string;
    /** used in schema groups */
    groupName: string;
    isGroupCoreSchemaField: boolean;

    schemaName: string;
    schemaTitle: string;
  };

  /** does not exist in the schema */
  value?: any;

  allowClear?: boolean;
}

export class IFormBuilderChangeEvent {
  fields: IFormField[];
  valid: boolean;
}
export class IFormChangeEvent {
  values: any;
  valid: boolean;
}

export type FormFieldType =
  | 'text'
  | 'area'
  | 'email'
  | 'number'
  | 'phone'
  | 'phone164'
  | 'date'
  | 'file'
  | 'section'
  | 'polar'
  | 'switch'
  | 'consent'
  | 'singleselect'
  | 'multiselect'
  | 'ontario_hc'
  | 'creditcard'
  | 'group';

export class CreateFormDto {
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  description: string;

  @IsOptional()
  @IsString()
  organization?: string;

  @IsArray()
  fields: IFormField[];
}

export class UpdateFormDto {
  @IsNotEmpty()
  @IsString()
  title: string;

  @IsOptional()
  @IsString()
  description: string;

  @IsOptional()
  @IsArray()
  fields: IFormField[];
}

export class CreateFormResponse extends IBaseResponse {
  form: IForm;
}
export class GetFormsDto {
  name?: string;
  _id?: string;
}

export type GetFormsResponse = IForm[];

export class IOntarioHealthCard {
  hcNum: string;
  hcVer: string;
  hcEff: Date;
  hcExp: Date;
}
